import { Component, OnInit, Input, Output, EventEmitter, Renderer2, HostListener, ViewChild, forwardRef } from "@angular/core";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { NgbModal, NgbModalConfig, NgbCollapse } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../services/authentication.service";
import { IUser } from "../interface/user";
import { EsriMapComponent } from "../esri-map/esri-map.component";
import { environment } from "src/environments/environment";
import { Globals } from "src/app/shared/globals";
// #TFS 25016
import { EventEmittersService } from "../services/event-emitters.service";
// #TFS 25016
import Swal from "sweetalert2";
import { faInfo, faQuestion } from "@fortawesome/free-solid-svg-icons";
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";
import version from "../../../package.json";
import { MMMAdminService } from "../admin-mmm/admin-mmm.reports.service";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { UserService } from "../services/user.service"; //added 11/16/25 to check if client is FabEnabled
import { CustomTranslatePipe } from "../shared/custom-translate.pipe";
import { AdministratorComponent } from "../admin-mmm/admin-mmm.component";
import { ChangeReportComponent } from "../admin-customer/change-report/change-report.component";
import { MapExportComponent } from "../admin-customer/map-export/map-export.component";
import { BulkinsertComponent } from "../admin-customer/bulkinsert/bulkinsert.component";
import { SetDefaultsComponent } from "../admin-customer/set-defaults/set-defaults.component";
import { AssetattributesComponent } from "../admin-customer/asset-attributes/asset-attributes.component";
import { GPSTrackComponent } from "../admin-customer/gpstrack/gpstrack.component";
import { UseradminComponent } from "../admin-customer/useradmin/useradmin.component";
import { MatButtonModule } from "@angular/material/button";
import { ReportsComponent } from "../admin-customer/reports/reports.component";
import { MatTabsModule } from "@angular/material/tabs";
import { ConfigurableHeaderComponent } from "../shared/configurable-header/configurable-header.component";
import { AngularDraggableModule } from "angular2-draggable";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";
import { MatIconModule } from "@angular/material/icon";
import { NgClass, NgIf } from "@angular/common";
import { IClient } from "../interface/client";
@Component({
    selector: "sms-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
    standalone: true,
    imports: [NgClass, NgbCollapse, NgIf, MatIconModule, CdkDrag, AngularDraggableModule, ConfigurableHeaderComponent, CdkDragHandle, MatTabsModule, 
              ReportsComponent, MatButtonModule, UseradminComponent, GPSTrackComponent, AssetattributesComponent, SetDefaultsComponent, 
              BulkinsertComponent, MapExportComponent, ChangeReportComponent, 
              forwardRef(() => AdministratorComponent), 
              TranslateModule, CustomTranslatePipe]
})
export class HeaderComponent implements OnInit {
  @ViewChild("adminTabs", { static: false }) tabs;
  //@HostListener("document:keydown.enter", ["$event"])   //7/14/26 removed keydown listener as in current configuration was causing click() to be called twice when tab to more button and hit Enter -- breaking the submenu functionality
  // onKeydownHandler(event: KeyboardEvent) {
  //   if (event.target["id"] === "more") {
  //     (<HTMLInputElement>event.target).click();
  //   }
  // }
  constructor(
    private global: Globals,
    private renderer: Renderer2,
    private EsriMapComponent: EsriMapComponent,
    private translateService: TranslateService,
    private modalService: NgbModal,
    config: NgbModalConfig,
    public authenticationService: AuthenticationService,
    // #TFS 25016
    private eeService: EventEmittersService, // #TFS 25016,
    private adminService: MMMAdminService,
    private userService: UserService
  ) {
    config.backdrop = "static";
    config.keyboard = false;
    this.currentUser = this.authenticationService.currentUserValue;
    translateService.setDefaultLang("1");
    translateService.use(this.currentUser.languageID.toString());
    // translateService.addLangs(['en', 'es']);
  }

  @Input() FeatureLayer: any;
  @Input() Query: any;
  @Input() Graphic: any;
  @Input() FeatureTable: any;
  @Input() QueryTask: any;
  @Input() map: any;
  @Input() TimeExtent;
  @Input() SimpleLineSymbol;
  @Input() SimpleRenderer;
  @Input() Color;
  @Input() TimeSlider;
  @Input() TimeInfo;
  @Input() registry;
  @Input() Popup;
  @Input() domConstruct;
  @Input() Geoprocessor;
  @Output() headerOptionEvent = new EventEmitter<string>();
  @Output() showCard = new EventEmitter();
  @Output() closeCrowdSourceBuilder = new EventEmitter();
  @Output() createTaskforAsset = new EventEmitter();
  @Output() crowdsource = new EventEmitter();

  public isCollapsed = true;
  jobSummarySubscription: Subscription;
  version = 1;
  notificationCount = 0;
  asstClickedES = true;
  currentJustify = "justified";
  currentUser: IUser = {} as IUser;
  dataEditorSettings;
  inBounds = true;
  activeTab = "";
  faInfo = faInfo;
  faQuestion = faQuestion;
  faQuesitonCircle = faQuestionCircle;
  settingNotification = false;
  ramhelp;
  appVersion = version.version;
  jcc_functional = false; //added to ngIfs to hide features that currently do not (never did?) work. remove from ngIf once functionality has been fixed and tested.
  public showMakeNav = false;

  showAdministration() /** Show Related Assets Accordian in card View */ {
    this.asstClickedES = !this.asstClickedES;
  }

  closeBuilder(event: any) {
    this.closeCrowdSourceBuilder.emit(event);
  }

  createTask(event: any) {
    this.createTaskforAsset.emit(event);
  }

  crowdSource() {
    this.crowdsource.emit();
  }

  optionClicked(event: any, type: string, content?) {
    const className = "i-active";
    const hasClass = event.target.parentElement.classList.contains(className);   
    if (type != "settings" && document.getElementById("adminNav") && document.getElementById("adminNav").classList.contains(className))
    {
      return; //ignore other nav buttons while Admin form is open 
    }
    if (type === "maintenanceViewer" && this.activeTab === "maintenanceViewer" && !hasClass){
      // maintenanceViewer was closed by X button on maintenance viewer ... from there Task button is deactivated by manually removing the i-active class but don't have access to update this.activeTab 
      this.activeTab = "";  
      document.getElementById("maintenanceViewer").classList.add(className);
    }
    if (type === "makeViewer" && this.activeTab === "makeViewer" && !hasClass){
      // makeViewer was closed by X button on make viewer ... from there Make button is deactivated by manually removing the i-active class but don't have access to update this.activeTab 
      this.activeTab = "";  
      document.getElementById("makeViewer").classList.add(className);
    }

    this.isCollapsed = !(this.isCollapsed === false && (type === "more" || type === "help")); // maintain uncollapsed state for nav with submenu when Nav is in hamburger button mode 
    this.activeTab = this.activeTab === type ? "" : type;

    // #TFS 25016
    if (type !== "more"){
      this.eeService.setSelectedFeaturesOnMap([]);
    }
    // #TFS 25016
    // tslint:disable-next-line:only-arrow-functions

    if (type === "add") {
      //TODO: Review this timeout to remove it to wait until setShowCard is set.
      if (this.eeService.addNewParent === false) {
        this.eeService.setAssetViewer(false);
        setTimeout(() => {
          this.eeService.setAssetViewer(true);
          this.eeService.addNewParent = true;
          this.eeService.setSelectedFeaturesOnMap([]);
        }, 500);
      }
    } else {
      this.eeService.setAssetViewer(false);
    }

    if (hasClass) {
      if (type === "administrator") {
        content.hide();
      }
      if (type === "settings") {
        this.global.content = content;
        if (content) {
          content.hide();
        }
      }

      if (type === "add") {
        this.showCard.emit(false);
      }
    } else {
      if (type === "administrator") {
        this.hideOtherComponent();
        this.showCard.emit(false);
        this.EsriMapComponent.invokePopup("");
        this.global.hideAdmin = content;
        this.global.adminstyle = event.target;

        if (this.global.hideSetting !== undefined) {
          this.global.hideSetting.hide();

          if (this.global.settingStyle !== undefined) {
            this.renderer.removeClass(this.global.settingStyle, className);
          }
        }

        content.show();
      }

      if (type === "settings") {
        this.EsriMapComponent.invokePopup("");
        this.hideOtherComponent();
        this.showCard.emit(false);
        this.global.hideSetting = content;
        this.global.content = content;
        this.global.settingStyle = event.target;

        if (this.global.hideAdmin !== undefined) {
          this.global.hideAdmin.hide();

          if (this.global.adminstyle !== undefined) {
            this.renderer.removeClass(this.global.adminstyle, className);
          }
        }
        //content.show();
      }
      if (type == "add") {
        this.showCard.emit(true);
      }
    }

    if (type !== "administrator" && type !== "settings" && type !== "crowdSource") {
      if (this.global.hideSetting !== undefined) {
        this.global.hideSetting.hide();
        if (this.global.settingStyle !== undefined) {
          this.renderer.removeClass(this.global.settingStyle, className);
        }
      }

      if (this.global.hideAdmin !== undefined) {
        this.global.hideAdmin.hide();
        if (this.global.adminstyle !== undefined) {
          this.renderer.removeClass(this.global.adminstyle, className);
        }
      }

      if (type === "more" || type === "help") {
        this.showCard.emit(false);
        this.eeService.setEnableSingleClick(true);
        this.hideOtherComponent();
        if (type == this.activeTab) {
          this.focusSubmenu(event, type+"Menu")
        }
      }
      this.headerOptionEvent.emit(type);
    } else {
      this.headerOptionEvent.emit(type);
    }

    if (type === "about") {
      Swal.fire({
        title: "About",
        imageUrl: "././assets/images/logo30px.svg",
        imageAlt: "3M RSAM logo",
        html: "<h4>Version " + this.appVersion + "</h4><br/>"
            + "<h4><a href='mailto:RoadwaySafetyAssetManager@mmm.com' style='color: rgb(0,0,255); font-weight:bold;'>Support Email</a></h4>"
            + "<h4><a href='https://www.3m.com/3M/en_US/company-us/privacy-policy/' target='_blank' rel='noopener noreferrer' style='color: rgb(0,0,255); font-weight:bold;'>Privacy Statement</a></h4>",
        confirmButtonText: "OK",
        inputAttributes: {
          "aria-label": "control not in use"
        },
        onOpen: () => {
           // 7/6/26 ADA
          const chkboxLbl = document.querySelector('.swal2-checkbox');
          if (chkboxLbl) {
            chkboxLbl.innerHTML += 'control not in use';
          }
        }
      });
      this.eeService.setEnableSingleClick(true);
    } else {
      this.eeService.setAssetViewer(false);
      this.eeService.addNewParent = false;
    }
  }

  focusSubmenu(event: any, submenuId: string){
      setTimeout(() => {
        const sm = document.getElementById(submenuId)
        if(sm) {
          const a = sm.querySelector('a');
          if(a) {
            a.focus();
          }
        }
      }, 0);
  }

  ngOnInit(): void {
    this.dataEditorSettings = JSON.parse(localStorage.getItem("dataEditorSettings"));
    //creates a subscription to the result of the getJobDetailsMethod() in the service it returns the most recent value from the behavior subject and reads all updates until destroyed.
    this.jobSummarySubscription = this.adminService
      .getJobDetails()
      .pipe(filter((data) => data !== null))
      .subscribe((data) => {
        this.notificationCount = 0;
        for (const job of data) {
          if (job.reviewDate == null && job.needsReview != null) {
            this.notificationCount++;
          }
        }
      });

    this.ramhelp = environment.apiBaseUrl + environment.helproot;

    this.userService.getClient(this.currentUser.clientId).subscribe((client: IClient) => {     
      this.showMakeNav = client.fabEnabled == 1 && 
        (this.currentUser.rolePermissions.fabOrders >= 1 || this.currentUser.rolePermissions.fabTracking >= 1 || this.currentUser.rolePermissions.fabHistory >= 1);
    });

  }

  ngOnDestroy(): void {
    this.jobSummarySubscription.unsubscribe();
    console.log(this.ramhelp);
    console.log(this.currentUser);
    console.log(this.appVersion);
  }

  // for ADA story - by Subba
  ngAfterViewInit() {
    const mainPageTools = document.querySelectorAll('[data-mainPageTabbing="yes"]');
    if (mainPageTools.length > 0) {
      mainPageTools.forEach((element) => {
        element.setAttribute("tabindex", "0");
      });
    }
  }

  switchLanguage(language: string) {
    this.translateService.use(language);
  }

  OpenPopup(content: any) {
    this.modalService.open(content, { centered: true, size: "xl" });
  }

  logout() {
    this.authenticationService.logout(this.currentUser.clientId, this.currentUser.userId);
  }

  capturescreen() {
    return this.EsriMapComponent.capturescreen();
  }
  hideOtherComponent() {
    this.EsriMapComponent.showSelect =
      this.EsriMapComponent.showSearch =
      this.EsriMapComponent.showLayers =
      this.EsriMapComponent.showFilter =
      this.EsriMapComponent.showMeasure =
      this.EsriMapComponent.showAdd =
      this.EsriMapComponent.showRedlineDraw =
      this.EsriMapComponent.closeHelpVar =
      this.EsriMapComponent.closeQueryBuilderVar =
      this.EsriMapComponent.DataEditor =
        false;
  }

  closeAdmin() {
    this.settingNotification = !this.settingNotification;
    this.activeTab="";

    //Added for ADA
    const mainPageTools = document.querySelectorAll('[data-mainPageTabbing="yes"]');
    const bMapTools = document.querySelectorAll('[data-BMapTabbing="yes"]');
    if (bMapTools.length > 0) {
      bMapTools.forEach((element) => {
        element.setAttribute("tabindex", "0");
      });
    }
    mainPageTools.forEach((element) => {
      element.setAttribute("tabindex", "0");
    });
  }
  catch(error) {
    console.error(error);
  }

}
